
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 3105","fill":"currentColor"}},[_c('path',{attrs:{"data-name":"Rectangle 1632","d":"M8.07 6.284h10.426v1.448H8.07z"}}),_c('path',{attrs:{"data-name":"Rectangle 1633","d":"M8.07 9.613h10.426v1.448H8.07z"}}),_c('path',{attrs:{"data-name":"Rectangle 1634","d":"M8.07 12.94h10.426v1.448H8.07z"}}),_c('path',{attrs:{"data-name":"Rectangle 1635","d":"M8.07 16.269h10.426v1.448H8.07z"}}),_c('path',{attrs:{"data-name":"Rectangle 1636","d":"M5.505 6.284h1.57v1.448h-1.57z"}}),_c('path',{attrs:{"data-name":"Rectangle 1637","d":"M5.505 9.613h1.57v1.448h-1.57z"}}),_c('path',{attrs:{"data-name":"Rectangle 1638","d":"M5.505 12.94h1.57v1.448h-1.57z"}}),_c('path',{attrs:{"data-name":"Rectangle 1639","d":"M5.505 16.269h1.57v1.448h-1.57z"}})])])
          )
        }
      }
    